import {hmapPathParamConfig, hmapPathParamRegex} from "../../modules/hmap/hmap.routes.js";

export var HrActionsTemplatesRoutes = {
    "/brand/:brand_id/hr-actions-templates": {
        "name": "appLayout.harriSH.hrActionsTemplates",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "component": "hrActionsTemplates",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./hr-actions-templates.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            }
        ]
    },

    [`/hr-actions-templates`]: {
        "name": "appLayout.harriSH.access-portal.settings.hrActionsTemplates",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "abstract": true,
        "component": "hrActionsTemplates",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./hr-actions-templates.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/offer-templates/offer-templates.module.js");
                }
            }
        ]
    },

    "/manage-actions": {
        "name": "appLayout.harriSH.hrActionsTemplates.manage",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "views": {
            'hr-actions-templates': {
                component: 'hrActionsTemplatesMain',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hr_actions_templates"]
        },
    },

    [`/manage-actions/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.settings.hrActionsTemplates.manage",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "views": {
            'hr-actions-templates': {
                component: 'hrActionsTemplatesMain',
            }
        },
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hr_actions_templates"]
        },
    },

};
